import { createElement, Fragment } from 'react';

import type { ILearningFaqItem } from '../interface/interface';

import { SOCIAL_MAX } from '../../../../../shared/lib/lib';

export const faqData: ILearningFaqItem[] = [
  {
    id: 1,
    title: 'Какие документы необходимы для зачисления?',
    content:
      'Слушателям необходимо проверить ранее введённые при регистрации данные, ввести в текстовом формате все необходимые дополнительные данные, а также прикрепить скан-копии: СНИЛС, диплома о высшем образовании, свидетельства о заключении брака или свидетельства о перемене имени (в случае, если имя участника в дипломе отличается от текущего имени), диплома о присуждении учёной степени (при наличии).',
  },
  {
    id: 2,
    title: 'Нужно ли подключаться онлайн и есть ли график занятий?',
    content:
      'Обучение реализуется полностью в дистанционном формате и включает видеолекции, текстовые материалы, конспекты, презентации и тестовые задания. Программа предусматривает асинхронный формат обучения, что позволяет самостоятельно планировать время изучения материалов в пределах установленного срока.',
  },
  {
    id: 3,
    title: 'Что делать, если не удалось пройти итоговое тестирование с первого раза?',
    content:
      'В конце каждого модуля предусмотрены тренировочные тесты, которые не влияют на итоговую оценку, но могут помочь вам подготовиться к прохождению итогового тестирования. Кроме того, вы можете пройти их повторно перед итоговым тестированием. В случае, если вам всё же не удастся пройти итоговое тестирование, организаторы обучения предоставят дополнительную попытку.',
  },
  {
    id: 4,
    title: 'Мой коллега тоже хочет пройти обучение, но не хочет участвовать в конкурсе',
    content:
      'Для прохождения обучения не обязательно заполнять анкету практики, достаточно только зарегистрироваться для участия в конкурсе и перейти в личный кабинет. После этого все авторизованные пользователи имеют равные права в прохождении обучения.',
  },
  {
    id: 5,
    title: 'К кому можно обратиться при возникновении технических вопросов?',
    content: createElement(
      Fragment,
      null,
      'Вы можете отправить электронное письмо оргкомитету конкурса (',
      createElement('a', { href: 'mailto:edtech@rut-miit.ru' }, 'edtech@rut-miit.ru'),
      '), написать сообщение в чат участников конкурса в MAX (',
      createElement(
        'a',
        { href: SOCIAL_MAX, target: '_blank', rel: 'noreferrer' },
        'ссылка'
      ),
      '). Кроме того, после зачисления вам станет доступен чат слушателей программы, где вы можете задавать содержательные и организационные вопросы.'
    ),
  },
  {
    id: 6,
    title: 'Будет ли учитываться обучение при оценке конкурсной работы?',
    content:
      'Прохождение программы повышения квалификации не влияет на результаты конкурсного отбора и не предоставляет дополнительных конкурсных преимуществ. Обучение реализуется как самостоятельная образовательная возможность для участников конкурса, но может помочь вам в оформлении и позиционировании своей практики.',
  },
  {
    id: 7,
    title: 'Можно ли приступить к обучению не сразу после зачисления?',
    content:
      'Рекомендуется начать обучение сразу после зачисления. Это позволит равномерно распределить учебную нагрузку и своевременно завершить программу в установленный срок.',
  },
  {
    id: 8,
    title: 'Будет ли возможность пройти обучение и после отборочного этапа?',
    content:
      'Рекомендуется начать обучение сразу после регистрации до заполнения анкеты практики — материалы курса могут вам помочь правильно оформить и выгодно описать свою педагогическую работу.',
  },
];
